import { LnCollapseGroup } from "src/components/LnCard/LnCollapseGroup";
import LnIcon from "src/components/LnIcon";
import { LinksGroupModelDiff } from "src/coursepart/domain/LinksGroupModel";
import LinkCardDiff from "./LinkCardDiff";
import GetDiffStateClass from "src/utils/StateColors";
import DOMPurify from 'dompurify';

export default function LinkGroupDiff(props: {
    group: LinksGroupModelDiff, partId: string
}) {

    const { group, partId } = props;

    const name = <div className="d-flex align-items-center"> <div dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(group.Name)}}></div>{group.Links.length > 0 ? <LnIcon name="slides" className="icon-small ms-3" /> : <></>}</div>;

    let bgstate = GetDiffStateClass(group.State);

    return <LnCollapseGroup bgclass={bgstate} groupName={name} isOpen={false}   >
        <div>
            {group.Links.map((item) => (
                    <LinkCardDiff key={item.Id} link={item} />
            ))}
        </div>
    </LnCollapseGroup>;



}